import ChartView from './Chart.view';

export default ChartView;
